export class QrCodeLogItem {
  constructor(json) {
    this.createdDate = json?.createdDate ?? null
    this.payer = json?.payer ?? null
    this.personaType = json?.personaType?.title ?? null
    this.caseType = json?.caseType?.title ?? null
    this.courtCase = json?.courtCase ?? null
    this.summa = json?.summa ?? null
  }
}